
import React, { createContext, useReducer, useContext } from "react";
import { withApollo } from '@apollo/react-hoc';
import { message } from 'antd'
import { withRouter } from 'react-router-dom';
import { createQuestionTemplateMut, updateQuestionTemplateMut, createQuestionTemplateActivityMut, listQuestionTemplatesBySlugValueQuery } from '../../../../common/graphqlFunctions'
import slugify from 'slugify';
import { configVariables } from '../../../../../configs/configs'
import { FormContext } from './context-reducer'
import { AuthContext } from '../../../../../context/authContext';
import { __debounce } from '../../../../common/functions'
import { searchQuestionsQuery } from '../../../../common/graphqlFunctions';


export const INIT_QUESTIONS = 'INIT_QUESTIONS'
export const SET_LOADING = 'SET_LOADING'
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING'
export const UPDATE_ALL_SLUG_QUES = 'UPDATE_ALL_SLUG_QUES'
export const RESET_ALL_SLUG_QUESTIONS = 'RESET_ALL_SLUG_QUESTIONS'
export const SET_TOBE_UPDATED = 'SET_TOBE_UPDATED'
export const SET_SEARCHED_DATA = 'SET_SEARCHED_DATA'



const bucket = configVariables.BUCKET;
const region = configVariables.REGION;


const initialState = {
  loading: false,
  allSlugValQuestions:[],
  toBeupdatedData:null,
  searchedData:[],
  searchLoading:false
};


const QuestionReducer = (state, action)=>{
    switch (action.type) {
        case SET_LOADING:
          return {...state, loading : action.payload }
        case UPDATE_ALL_SLUG_QUES:
            return {...state, allSlugValQuestions : action.payload }
        case RESET_ALL_SLUG_QUESTIONS:
            return {...state, allSlugValQuestions : []}
        case SET_TOBE_UPDATED:
            return {...state, toBeupdatedData: action.payload }
        case SET_SEARCHED_DATA:
            return {...state, searchedData: action.payload}
        case SET_SEARCH_LOADING:
            return {...state, searchLoading: action.payload}
        default:
          return state
      }
}


const QuestionStore = (props) => {
  const authContextComp = useContext(AuthContext);

  const [state, dispatch] = useReducer(QuestionReducer, initialState);
  const context = useContext(FormContext);

  let subScriber = 'global';
  if(authContextComp.data && authContextComp.data != null){
    subScriber = authContextComp.data.subscriberId
  }
  
  const setloading=(flag)=>{
    dispatch({
      type:SET_LOADING,
      payload: flag
    })
  }

  const setSearchloading=(flag)=>{
    dispatch({
      type:SET_SEARCH_LOADING,
      payload: flag
    })
  }

 

  const getAllQuestionsBySlug=(slugValue)=>{
    setloading(true)
    let variablesSlug={
      subscriberId: subScriber,
      slugValue: slugValue
  }
  listQuestionTemplatesBySlugValueQuery(props,variablesSlug)
  .then(({data})=>{
      dispatch({
          type: UPDATE_ALL_SLUG_QUES,
        //   payload: data.listQuestionTemplatesBySlugValue
          payload: data.listQuestionTemplatesBySlugValue.map((a,i)=>{
              a.key = i;
              return a
          })
      })

      if( props.setquesModal){
          props.setquesModal(false)
      }
      setloading(false)
  }).catch((err)=>{
  
    setloading(false)
  })
}

  const resetAllSlugQuesitons=(flag)=>{
    dispatch({
      type:RESET_ALL_SLUG_QUESTIONS,
      payload: []
    })
  }


  const returnQuestionObjTable = (values) => {
      let variables = {}
      variables = returnQuestionObj(values)
    return variables
}

const setToBeUpdatedData=(payload)=>{
    dispatch({
        type: SET_TOBE_UPDATED,
        payload: payload
    })
}


const setsearchedData=(payload)=>{
    dispatch({
      type:SET_SEARCHED_DATA,
      payload: payload
    })
  }


const handleSearch=(q, token = null, arr2=[])=>{
    setSearchloading(true)
    let variables = {
      typeValue: `${context.subScriber}::question`,
      searchValue: q.toLowerCase(),
      limit: 1000,
      nextToken: token
    }
    searchQuestionsQuery(props,variables)
    .then(({data})=>{
      let arr = [...arr2];
      let arr3 = []
      if(data.searchQuestions.items.length > 0){
        let arr1 = data.searchQuestions.items.filter((a)=>{
          if(arr.findIndex((b)=>b.slugValue == a.slugValue) == -1){
            return a
          }
        })
        if(arr1.length > 0){
        }
        
        arr3 = [].concat(arr,arr1);
      }else{
        arr3 = arr
      }
  
      if(arr3.length < 10 && data.searchQuestions.nextToken != null){
        handleSearch(q,data.searchQuestions.nextToken, arr3)
        setSearchloading(true)
      }
   
      if(data.searchQuestions.nextToken == null){
        setSearchloading(false)
      }
        setsearchedData(arr3)
       
      })
      .catch((err)=>{
        console.log(err)
      })
  }
  


const returnAnswerResponse=(values, variables)=>{
    const { type, summary, response } = values;
    switch (type) {
        case 'SINGLE_LINE':
            variables.freeText = {
                answerSummary: summary,
                textInputType: 'SINGLE_LINE'
            }
            break;
        case 'MULTI_LINE':
            variables.freeText = {
                answerSummary: summary,
                textInputType: 'MULTI_LINE'
            }
            break;
        case 'FREE_TEXT':
            variables.freeText = {
                answerSummary: summary,
                textInputType: 'SINGLE_LINE'
            }
            break;
        case 'NUMBER':
            variables.number = {
                answerSummary: summary,
                // variations: values.response ? values.response : []
            }
            break;
        case 'LIST':
            variables.list = {
                answerSummary: summary,
            }
            break;
        case 'DATE':
            variables.date = {
                answerSummary: summary,
            }
            break;
        case 'FILE':
            variables.file = {
                answerSummary: summary
            }
            break;
        case 'RADIO_BUTTON':
            variables.radioList = response.map((item) => {
                return {
                    optionTitle: item.response,
                    optionSummary: item.summary,
                    freeTextRequired: false
                }
            })
            if(values.radioDisplayType && values.radioDisplayType == 'DROPDOWN'){
                variables.radioDisplayType = 'DROPDOWN'
            }
            break;
        case 'CHECK_BOX':
            variables.checkboxList = response.map((item) => {
                return {
                    optionTitle: item.response,
                    optionSummary: item.summary,
                    freeTextRequired: false
                }
            })
            break;
        case 'SELECT':
            variables.select = response.map((item) => {
                return {
                    optionTitle: item.response,
                    optionSummary: item.summary,
                    freeTextRequired: false
                }
            })
            break;
        case 'FILL_IN_BLANKS':
            variables.fillInBlanks = {
                answerSummary: summary,
                blanksType : values.typeArray
            }
            break;
        default:
            break;
    }
    return variables
}


const returnQuestionObj=(values)=>{
    var { questionTitle, questionType, helpText, appliedFor, age, required, attachImage, addNote,addNotApplicable,addPainCalculation, allowToPrint, selectedPainScoreQuestions } = values;
    let variables={};
    let slugValue = slugify(questionTitle.trim(), {
        lower: true
    });
    
    questionType = questionType == 'SINGLE_LINE' || questionType == 'MULTI_LINE' ? "FREE_TEXT" : questionType;
    variables = {
        typeValue: `${subScriber}::question`,
        addNote: addNote, 
        addNotApplicable: addNotApplicable,
        addPainCalculation: addPainCalculation,
         allowToPrint: allowToPrint, 
          selectedPainQue: selectedPainScoreQuestions ? selectedPainScoreQuestions : "",
        // slugValue: slugValue+Date.now().toString(),
         slugValue: slugValue,
        questionTitle: questionTitle,
        questionType: questionType,
        helpText: helpText,
        appliedFor: appliedFor,
        // ageFrom: age.from,
        // ageTo: age.to,
        isRequired: required
    }
   
    if(values.age){
        variables.ageFrom = values.age.from;
        variables.ageTo = values.age.to;
    }
    variables = returnAnswerResponse(values, variables);


    if (questionType == 'TABLE') {
        variables = returnTableResponse(values, variables);
    }
    if((questionType == 'RADIO_BUTTON' || questionType == 'CHECK_BOX') && attachImage == true){
        variables = returnRefImageResponse(values, variables, slugValue);
    }

    return variables
}


const returnTableResponse=(values, variables)=>{

    let mainObj = {}
    mainObj.table = values.tableQuesArray;
    mainObj.columnHeaders = values.columnHeaders;
    mainObj.rowHeaders = values.rowHeaders;
    mainObj.columnsCount = values.noOfColumns;
    mainObj.rowsCount = values.noOfRows;
    mainObj.summary = values.summary;

    let arr = values.tableQuesArray

    for (let i = 0; i < arr.length; i++) {
        let subArr = arr[i];
        for (let j = 0; j < subArr.length; j++) {
            let type = subArr[j].questionType;

            if (subArr[j].questionType == 'FREE_TEXT') {
                type = subArr[j].freeText ? subArr[j].freeText.textInputType : subArr[j].questionType
            }

            let obj = { ...values, ...subArr[j], type: type }

            let returnObj = returnQuestionObjTable(obj)
            mainObj.table[i][j] = returnObj;
        }
    }
    let tableValues = { 'json': mainObj };

    variables.tableValues = JSON.stringify(tableValues)
    return variables;
}


const returnRefImageResponse=(values,variables, slugValue)=>{
    const { uploadedImageFile, uploadedImage, imageObj } = values;
    variables.refImage = {};
  
    if ( uploadedImage != null && uploadedImage.key) {
        variables.refImage.imgUrl = {
            bucket: uploadedImage.bucket,
            region: uploadedImage.region,
            key: uploadedImage.key,
        }
    } else {
        variables.refImage.imgUrl = {
            bucket: bucket,
            region: region,
            localUri: uploadedImageFile.originFileObj,
            key: `forms/images/${slugValue}/` + uploadedImageFile.name,
            mimeType: uploadedImageFile.type,
            // dataUrl : uploadedImage
        }
        // variables.dataUrl = uploadedImage;
    }

    variables.refImage.areas = imageObj.areas.map((item) => {
        return {
            coords: item.coords,
            lineWidth: item.lineWidth,
            name: item.name,
            preFillColor: item.preFillColor,
            shape: item.shape
        }
    });
 
    return variables
}


  const createQuestionOnFinish=(values, record, form, props)=>{

      let addToMainFlag = values.addToQuestionBank == true ? true : false;

      const { runMutation, status } = props;

      let variables = returnQuestionObj(values);

    //   if(variables.refImage){
    //     delete variables.refImage.imgUrl.dataUrl
    //   }
    if(runMutation == false && addToMainFlag == false){

        if(values.conditions){
            variables.conditions = values.conditions;
        }
        if (values.selectedPainQue) {
               
                variables.selectedPainScoreQuestions = values.selectedPainScoreQuestions
        }
        if(props.setquesModal){
            props.setquesModal(false)
        }
        if (props.updateQuestion) {
            variables.changesOptions = values.changesOptions;
            props.updateQuestion(variables)
        }

        form.resetFields()
        return;
      }

      if (record == null) {
            setloading(true)
            createQuestionTemplateMut(props, variables)
            .then((res) => {
                setloading(false)
                
                context.updateQuestionsData(res.data.createQuestionTemplate)
                form.resetFields()

                if (res.data.createQuestionTemplate != null) {
                    message.success('Question is created successfully');
                    if(props.setquesModal){
                        props.setquesModal(false)
                    }
                    if (props.updateQuestion) {
                        variables.changesOptions = values.changesOptions;
                        props.updateQuestion(variables)
                    }
                    if(subScriber != 'global'){
                        let activityVariables={
                            typeValue: variables.typeValue,
                            slugValue: variables.slugValue,
                            uId: res.data.createQuestionTemplate.uId
                        }
                        createQuestionTemplateActivityMut(props,activityVariables)
                        .then(({data})=>{
                            console.log(data)
                            
                        })
                        .catch((err)=>{
                            console.log(err)
                        })
                    }
                }
            }).catch((err) => {
                console.log(err)
                setloading(false)
                message.error('Question may be already created, please check question title.')
            })
          
      } else {
          if (record != null) {
              if(variables.questionTitle == record.questionTitle){
                //   console.log(variables)
                  setloading(true)
                  updateQuestionTemplateMut(props, variables)
                  .then((res) => {
                      setloading(false)
              
                      context.updateQuestionsData(res.data.updateQuestionTemplate)
                      form.resetFields()
  
                      if (res.data.updateQuestionTemplate != null) {
                          message.success('Question is Updated successfully');
                          if (props.updateQuestion) {
                              variables.changesOptions = values.changesOptions;
                              props.updateQuestion(variables)
                          }
  
                      }
                  }).catch((err) => {
                      console.log(err)
                      setloading(false)
                  })
              }else{
                setloading(true)
                createQuestionTemplateMut(props, variables)
                .then((res) => {
                    setloading(false)
                    
                    context.updateQuestionsData(res.data.createQuestionTemplate)
                    form.resetFields()
    
                    if (res.data.createQuestionTemplate != null) {
                        message.success('Question is created successfully');
                        if(props.setquesModal){
                            props.setquesModal(false)
                        }
                        if (props.updateQuestion) {
                            variables.changesOptions = values.changesOptions;
                            props.updateQuestion(variables)
                        }
                        if(subScriber != 'global'){
                            let activityVariables={
                                typeValue: variables.typeValue,
                                slugValue: variables.slugValue,
                                uId: res.data.createQuestionTemplate.uId
                            }
                            createQuestionTemplateActivityMut(props,activityVariables)
                            .then(({data})=>{
                                console.log(data)
                            })
                            .catch((err)=>{
                                console.log(err)
                            })
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    setloading(false)
                    message.error('Question may be already created, please check question title.')
                })
              }
          }
      }
  }

  const updateAllQuestions=()=>{
   return new Promise((resolve,reject)=>{
    setloading(true)
    let arr = []
    for(let i = 0; i < state.allSlugValQuestions.length; i++){
        let item = state.allSlugValQuestions[i]
 
        let obj = state.toBeupdatedData;
      
        let newObj = {...item,...obj}
 
        newObj.active = item.active;
        newObj.createdAt = item.createdAt;
        newObj.uId = item.uId;
        newObj.typeValue = item.typeValue;
        newObj.isRequired = item.isRequired;
        
        for (let entry in newObj) { 
            if((entry == 'radioList' || entry == 'checkboxList') && newObj[entry] != null){
                newObj[entry].map((k)=>{
                    delete k['__typename'];
                })
            }
            if((entry == 'freeText' || entry == 'number' || entry == 'date' || entry == 'file' || entry == '') && newObj[entry] != null){
                delete newObj[entry]['__typename'];
            }
            if((entry == 'freeText' || entry == 'number' || entry == 'date' || entry == 'file' || entry == '') && newObj[entry] != null){
                delete newObj[entry]['__typename'];
            }
            if(entry == 'fillInBlanks' && newObj[entry] != null){
                delete newObj['fillInBlanks']['__typename']
            }
            if(entry == '__typename'){
                delete newObj['__typename']
            }
        }
        
      arr.push( updateQuestionTemplateMut(props, newObj))

    }

    Promise.allSettled(arr)
    .then((data)=>{
   
        dispatch({
            type: RESET_ALL_SLUG_QUESTIONS,
            payload: []
        })
    
        dispatch({
            type: SET_TOBE_UPDATED,
            payload: null
        })
        setloading(false)
        resolve()
    }).catch((err)=>{
        console.log(err)
        reject()
    })
   
    })
   
  }
 

  return (
      <QuestionContext.Provider 
      value={{
        state, 
        createQuestionOnFinish, 
        resetAllSlugQuesitons, 
        updateAllQuestions, 
        getAllQuestionsBySlug,
        setToBeUpdatedData,
        handleSearch
      }}>
          {props.children}
      </QuestionContext.Provider>
  )
};


const QuestionContext = createContext(initialState);


const QuestionStoreW = withRouter(withApollo(QuestionStore))


export {
  QuestionReducer,
  QuestionStoreW,
  QuestionContext
}


